import { SelectionEntry } from "@app/components/core/SelectionEntry/SelectionEntry"
import { SelectionGroup } from "@app/components/core/SelectionGroup/SelectionGroup"
import { emptyArray } from "@app/utils/objectUtils"
import Skeleton from "react-loading-skeleton"

export default function LoadingSelectorPage({ show, showTitle, length }) {
	if (!show) return null

	return (
		<SelectionGroup
			title={
				showTitle && (
					<>
						<span className="uppercase">
							<Skeleton />
						</span>
					</>
				)
			}
		>
			{emptyArray(length).map((_, index) => (
				<SelectionEntry isSkeleton key={index} />
			))}
		</SelectionGroup>
	)
}
